// eslint-disable-next-line no-use-before-define
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, List } from 'antd';
import { getProcTaskInit } from 'services/workflow';

/**
 * @deprecated Use TasksListPopover instead
 */
class POPOverTaskList extends Component {
  static propTypes = {
    isdocid:PropTypes.number,
    handlerPopOverEventList: PropTypes.func,
    isVisibleEvent: PropTypes.bool,
    object: PropTypes.any,
    objectid: PropTypes.number,
    objectreference: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      objectid:props.objectid,
      isdocid:0,
      isVisibleEvent: false,
      eventList: [],
    };
  }

  hideEvents = () => {
    this.setState({ isVisibleEvent: false,isdocid:0 });
    this.props.handlerPopOverEventList(null, null, null, false);
  };

  UNSAFE_componentWillReceiveProps(props) {
    const { isVisibleEvent, object, objectid,isdocid } = props;
    this.setState({ isVisibleEvent,isdocid });

    if (objectid != null) {
      this.loadAvailableActions(object, objectid);
    }
  }

  loadAvailableActions(entity, entityid) {
    getProcTaskInit({entity:entity, entityid:entityid}).then((response) => {
      this.setState({ eventList: response.list });
    });
  }

  render() {
    const { isVisibleEvent, eventList, objectid,isdocid } = this.state;
    const { objectreference } = this.props;

    const content = (
      <div
        style={{
          fontWeight: 'bold',
          width: '300px',
          color: 'blue',
          fontSize: '14px',
        }}
      >
        <List
          itemLayout="horizontal"
          dataSource={eventList}
          renderItem={({ taskid, tasklabel, funcode }) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <a
                    onClick={(e) => {
                      if(objectid===isdocid && isdocid!==0){
                      e.stopPropagation();
                      this.setState({ isVisibleEvent: false });
                      this.props.handlerPopOverEventList(
                        taskid,
                        tasklabel,
                        funcode,
                        false
                      );
                    }
                    }}
                  >
                    {tasklabel}
                  </a>
                }
              />
            </List.Item>
          )}
        />
        <a onClick={this.hideEvents}>Close</a>
      </div>
    );
    if(isVisibleEvent && objectid===isdocid && isdocid!==0){

    return (
      <Popover
        content={content}
        title={`Available Tasks on : ${objectreference}`}
        placement="bottomRight"
        visible={()=>{return isVisibleEvent && objectid===isdocid && isdocid!==0}}
      />
    );

    }
    else {return null}
  }
   
}

export default POPOverTaskList;
